<script>
import BaseDropzone from './base-dropzone'
import Dropzone from 'dropzone'

export default {
  name: 'DirectDropzone',
  extends: BaseDropzone,

  props: {
    maxFilesizeMb: {
      type: Number,
      required: false,
      default: 10
    },
    paramName: {
      type: String,
      required: true
    },
    uploadUrl: {
      type: String,
      required: true
    }
  },

  emits: ['upload-error', 'upload-success'],

  mounted() {
    const component = this
    const options = {
      ...this.commonDropzoneOptions,
      maxFiles: 1,
      maxFilesize: this.maxFilesizeMb,
      method: 'patch',
      paramName: this.paramName,
      url: this.uploadUrl,
      headers: {
        'Accept': 'application/json'
      },
      success(file, response) {
        if (response.status === 'error') {
          component.$emit('upload-error', response)
        } else {
          component.$emit('upload-success', response)
        }
      },
      error(file, errorMessage, xhr) {
        if (xhr) {
          component.$emit('upload-error', xhr.response)
        } else {
          component.$emit('upload-error', {message: errorMessage})
        }
      }
    }
    const tokenElement = document.querySelector('meta[name="csrf-token"]')
    if (tokenElement) {
      options.headers = { 'X-CSRF-Token': tokenElement.getAttribute('content') }
    }
    this.dropzone = new Dropzone(this.$el, options)
  },

  methods: {
    clearFile() {
      this.dropzone.removeAllFiles()
    }
  }
}
</script>
